var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "boss-scoutandlike-item",
      class: { "boss-period-end": !_vm.isPublished },
    },
    [
      _c("div", { staticClass: "boss-main-content-wrap" }, [
        _c(
          "h2",
          {
            staticClass: "boss-joboffer-title",
            class: { "boss-contract": _vm.isPublished },
          },
          [
            _vm._v(
              "\n      求人ID:" +
                _vm._s(_vm.job.id) +
                " " +
                _vm._s(_vm.job.managementName) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-scoutandlike-item-list" },
          [
            _c("scout-topic-recommendation", {
              attrs: {
                "job-id": _vm.job.id,
                "contract-id": _vm.contractId,
                "is-published": _vm.isPublished,
              },
            }),
            _vm._v(" "),
            _c("scout-topic-search-condition", {
              attrs: {
                "job-id": _vm.job.id,
                "search-condition-id": _vm.searchConditionId,
                "contract-id": _vm.contractId,
              },
            }),
            _vm._v(" "),
            _c("scout-topic-candidate", {
              attrs: {
                "job-id": _vm.job.id,
                "contract-id": _vm.contractId,
                count: _vm.candidatesCount,
              },
            }),
            _vm._v(" "),
            _c("scout-topic-scouted", {
              attrs: {
                "job-id": _vm.job.id,
                "contract-id": _vm.contractId,
                "scout-end-date": _vm.job.scoutEndDate,
                count: _vm.scoutedCount,
              },
            }),
            _vm._v(" "),
            _c("scout-topic-reservation", {
              attrs: {
                "job-id": _vm.job.id,
                "contract-id": _vm.contractId,
                "reservation-count": _vm.reservationCount,
                "reservation-user-count": _vm.reservationUserCount,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }